import { render, staticRenderFns } from "./ShowRelationshipPanel.vue?vue&type=template&id=63722614&scoped=true"
import script from "./ShowRelationshipPanel.vue?vue&type=script&lang=ts"
export * from "./ShowRelationshipPanel.vue?vue&type=script&lang=ts"
import style0 from "./ShowRelationshipPanel.vue?vue&type=style&index=0&id=63722614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63722614",
  null
  
)

export default component.exports